import { FC, PropsWithChildren } from "react";

import {
  DropdownSourceContext,
  useDropdownItemsCtxProvider,
} from "@ryde/redux";

export const DropdownSourceContextWrapper: FC<PropsWithChildren> = ({
  children,
}) => {
  const hookData = useDropdownItemsCtxProvider();

  return (
    <DropdownSourceContext.Provider value={hookData}>
      {children}
    </DropdownSourceContext.Provider>
  );
};
